import React, { useEffect, useState } from 'react';
import { RxCross2 } from "react-icons/rx";
import ModalHeading from '../../components/shared/modal-heading';
import Button from '../../components/shared/custom-btn';
import CustomInput from '../../components/shared/custom-input';
import { validateForm } from '../../utils/form-validator-utils';
import { updateUser } from '../../services/users-service';

const ResetPassModal = ({ email = 'abc@gmail.com', close, accountId, userId }) => {
    const [formData, setFormData] = useState({
        email: '',
        newPass: '',
        confirmPass: '',
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [apiError, setApiError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        if (email) {
            setFormData(prev => ({
                ...prev,
                email: email
            }));
        }
    }, [email]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        // Clear error for the field being edited
        setErrors(prev => ({ ...prev, [name]: '' }));
        setApiError('');
        setSuccessMessage('');
    };

    const handleSave = async () => {
        // Validate form
        const { errors: validationErrors, isValid } = validateForm(
            {
                email: formData.email,
                password: formData.newPass,
                confirmPassword: formData.confirmPass
            },
            ['email', 'password', 'confirmPassword']
        );

        setErrors(validationErrors);

        if (!isValid) {
            return;
        }

        setIsLoading(true);
        setApiError('');
        setSuccessMessage('');

        try {
            // Call updateUser API with the new password
            const response = await updateUser(accountId, userId, {
                password: formData.newPass
            });

            console.log(response)

            if (response.success) {
                setSuccessMessage('Password updated successfully!');
                // Optionally close modal after 2 seconds
                setTimeout(() => {
                    close();
                }, 2000);
            } else {
                setApiError(response.data.message || 'Failed to update password');
            }
        } catch (error) {
            setApiError('An error occurred while updating the password');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="space-y-3 px-4 pt-3 pb-3 relative">
            <ModalHeading className="text-left mb-3">Change Password</ModalHeading>

            <button
                className='hover:scale-105 absolute -top-3 -right-2 bg-white border p-2 rounded-full'
                onClick={close}
                disabled={isLoading}
            >
                <RxCross2 className='text-xl' />
            </button>

            {apiError && (
                <div className="text-red-600 bg-red-500 w-full text-sm p-2 rounded-md">
                    {apiError}
                </div>
            )}

            {successMessage && (
                <div className="text-green-600 bg-green-100 w-full text-center text-sm p-2 rounded-md ">
                    {successMessage}
                </div>
            )}

            <div className="grid grid-cols-1 gap-2">
                <CustomInput
                    label="Email"
                    name="email"
                    type="email"
                    inputType="email"
                    value={formData.email}
                    onChange={() => { }}
                    inputStyle={''}
                    labelGap={'!gap-0.5'}
                    labelStyle={'text-gray-700'}
                    required={true}
                    disabled
                    error={errors.email}
                />
                <CustomInput
                    label="Enter New Password"
                    name="newPass"
                    type="password"
                    inputType="password"
                    value={formData.newPass}
                    onChange={handleInputChange}
                    inputStyle={''}
                    labelGap={'!gap-0.5'}
                    labelStyle={'text-gray-700'}
                    required={true}
                    error={errors.password}
                />
                <CustomInput
                    label="Confirm Password"
                    name="confirmPass"
                    type="password"
                    inputType="password"
                    value={formData.confirmPass}
                    onChange={handleInputChange}
                    inputStyle={''}
                    labelGap={'!gap-0.5'}
                    labelStyle={'text-gray-700'}
                    required={true}
                    error={errors.confirmPassword}
                />

                <div className="flex justify-end px-4">
                    <Button
                        label={"Save"}
                        type="button"
                        loadingLabel='Saving...'
                        loading={isLoading}
                        className={`bg-btnBg rounded-lg !py-1 text-white ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        onClick={handleSave}
                        disabled={isLoading}
                    />
                </div>
            </div>
        </div>
    );
};

export default ResetPassModal;
